
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"160","height":"160"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M66.566 73.199a5 5 0 115-5 5 5 0 01-5 5zm0-7.5a2.5 2.5 0 102.5 2.5 2.5 2.5 0 00-2.5-2.5zm-2.5 31.108a1.249 1.249 0 01-1.233-1.1l-1.117-8.9h-1.4a1.25 1.25 0 01-1.25-1.25v-3.75a7.5 7.5 0 017.5-7.5 1.25 1.25 0 010 2.5 5 5 0 00-5 5v2.5h1.25a1.231 1.231 0 011.233 1.1l1.117 8.9h3.9a1.25 1.25 0 010 2.5zm27.5-23.608a5 5 0 115-5 5 5 0 01-5 5zm0-7.5a2.5 2.5 0 102.5 2.5 2.5 2.5 0 00-2.5-2.5zm-2.5 31.108a1.25 1.25 0 110-2.5h3.9l1.117-8.9a1.249 1.249 0 011.233-1.1h1.25v-2.5a5 5 0 00-5-5 1.25 1.25 0 010-2.5 7.5 7.5 0 017.5 7.5v3.75a1.259 1.259 0 01-1.25 1.25h-1.4l-1.117 8.9a1.25 1.25 0 01-1.233 1.1zm-10-24.858a6.25 6.25 0 116.25-6.25 6.25 6.25 0 01-6.25 6.25zm0-10a3.75 3.75 0 103.75 3.75 3.75 3.75 0 00-3.75-3.75z"}}),_c('path',{attrs:{"d":"M76.25 99.918A1.229 1.229 0 0175 98.833l-1.134-10.878h-2.617a1.224 1.224 0 01-1.25-1.2v-3.588a10.01 10.01 0 0120 0v3.588a1.233 1.233 0 01-1.25 1.2h-2.617L85 98.849a1.232 1.232 0 01-1.25 1.068zm6.367-2.392l1.133-10.9a1.232 1.232 0 011.25-1.07h2.5v-2.392a7.507 7.507 0 00-15 0v2.392H75a1.244 1.244 0 011.25 1.085l1.133 10.88z"}})])
          )
        }
      }
    